<script>
  import { contentComputed } from '@state/helpers'
  import appConfig from "@src/app.config.json"
  import List from "@components/list/list.vue";

  export default {
    page: {
      title: 'Publishers',
      meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { List },

    computed: {
      ...contentComputed
    }
}
</script>

<template>
  <div>
    <List
      class="mt-5"
      :count="[1, 1, 2, 3]"
      source="publishers.list"/>

    <div class="text-center mt-5">
      <p class="lead">
        <small>{{ info.publishers.disclaimer }}</small>
      </p>
    </div>
  </div>
</template>
